import callWebGate from 'api/callWebGate';
import debug from 'debug';

const log = debug('api:payments');

export const DEFAULT_ADYEN_FETCH_ERROR = 'There was a problem fetching your payment information. Contact adstudio@spotify.com if you\'re having trouble.';
export const DEFAULT_ADYEN_HPP_REDIRECT_ERROR = 'There was a problem processing your payment request. Contact adstudio@spotify.com if you\'re having trouble.';
export const ADYEN_INVALID_CARD_ERROR = 'Enter a valid credit card number. Contact adstudio@spotify.com if you\'re having trouble.';

export function AdyenRecurringDetailNotFoundError() {
  Error.call(this);
}

export function AdyenRecurringDetailNotificationPendingError() {
  Error.call(this);
}

export function AdyenRecurringDetailError(message) {
  Error.call(this);
  this.message = message;
}

export function getAdyenRecurringDetails(accessToken, webGate = callWebGate) {
  return webGate('adsgtm/v1/adyen/card', accessToken)
    .then(r => {
      switch (r.status) {
        case 404:
          return Promise.reject(new AdyenRecurringDetailNotFoundError());
        case 406:
          return r.json().then(() => Promise.reject(new AdyenRecurringDetailError(ADYEN_INVALID_CARD_ERROR)));
        case 204:
          return Promise.reject(new AdyenRecurringDetailNotificationPendingError());
        case 200:
          return r.json();
        default:
          return r.text().then(e => {
            const errorMessage = e || DEFAULT_ADYEN_FETCH_ERROR;
            log('getAdyenRecurringDetails response error: %s', errorMessage);
            return Promise.reject(new Error(errorMessage));
          });
      }
    });
}

export function getAdyenHPPFormDetails(accessToken, webGate = callWebGate) {
  return webGate('adsgtm/v2/adyen/hpp', accessToken)
    .then(r => {
      switch (r.status) {
        case 200:
          return r.json();
        default:
          return r.text().then(e => {
            const errorMessage = e || DEFAULT_ADYEN_HPP_REDIRECT_ERROR;
            log('getAdyenHPPFormDetails response error: %s', errorMessage);
            return Promise.reject(new Error(errorMessage));
          });
      }
    });
}

export function linkCardToAdyenUser(accessToken, params, webGate = callWebGate) {
  const opts = {
    method: 'POST',
    body: JSON.stringify(params),
  };
  return webGate('adsgtm/v1/adyen/card/link', accessToken, opts)
    .then(r => {
      if (r.ok) {
        return Promise.resolve();
      }

      return Promise.reject(new Error('Failed to link card to adyen user.'));
    });
}



// WEBPACK FOOTER //
// ./src/api/payments.js